var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasNotifications)?_c('div',{attrs:{"id":"notifications"}},[(_vm.notificationConnection)?_c('div',{staticClass:"alert alert-danger",attrs:{"id":"notification_connection"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Connection lost!")]),_vm._v(" "),_c('p',[_vm._v("Attempting to restore connection. Changes made now are not saved.")])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e1d21e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/notifications.vue
// module id = 1551
// module chunks = 1